import React, { memo, useCallback } from 'react';
import { classNameBind } from '@wconcept/wconcept-common/utils/commonUtils';
import Button from '@wconcept/wconcept-ui-renewal/components/atoms/Button';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import Img from '@wconcept/wconcept-ui-renewal/components/atoms/Img';
import { getResizeImageUrl } from '@wconcept/wconcept-common/utils/domainUtil';
import * as S from './style';

interface IProps {
  title1?: string;
  title2?: string;
  subTitle?: string;
  imgSrc?: string;
  className?: string;
  priority?: boolean;
  rs?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const MainBannerItemType2 = ({
  title1,
  title2,
  subTitle,
  imgSrc,
  className,
  priority,
  rs,
  onClick,
}: IProps) => {
  const cName = classNameBind(['main-banner-item-type2', className || '']);

  const getButtonRender = useCallback(
    () => (
      <Button onClick={onClick}>
        <Img
          className="thumbnail"
          priority={priority}
          src={getResizeImageUrl(imgSrc, rs)}
        />

        {(title1 || title2 || subTitle) && (
          <span className="textBox">
            {title1 && (
              <Text className="title1" ellipsis={1}>
                {title1}
              </Text>
            )}

            {title2 && (
              <Text className="title2" ellipsis={1}>
                {title2}
              </Text>
            )}

            {subTitle && (
              <Text className="subTitle" ellipsis={1}>
                {subTitle}
              </Text>
            )}
          </span>
        )}
      </Button>
    ),
    [imgSrc, onClick, priority, rs, subTitle, title1, title2]
  );

  return (
    <S.MainBannerItemType2 className={cName}>
      {getButtonRender()}
    </S.MainBannerItemType2>
  );
};

export default memo(MainBannerItemType2);
